import React from "react";
import { Skeleton } from "@mui/material";

const LiveChatFinancialDocumentSkeleton = () => {
  return (
    <div className="tw-w-full tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-overflow-hidden tw-pb-4">
      {/* Tabs Skeleton */}
      <div className="tw-px-8 tw-my-3 tw-overflow-hidden tw-h-[60px]">
        <nav className="tw-flex tw-w-full tw-gap-2">
          {[1, 2, 3, 4, 5].map((index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={100}
              height={40}
              className="tw-rounded-lg tw-bg-gray-200"
            />
          ))}
        </nav>
      </div>

      <div className="tw-flex tw-gap-4 tw-px-8">
        {/* Document List Skeleton */}
        <div className="tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB] tw-rounded-lg tw-p-5 tw-w-[25%]">
          {[1, 2, 3, 4].map((index) => (
            <div
              key={index}
              className="tw-mb-4 tw-p-4 tw-flex tw-justify-between tw-items-center"
            >
              <Skeleton
                variant="text"
                width={150}
                height={24}
                className="tw-bg-gray-200"
              />
              <Skeleton
                variant="circular"
                width={20}
                height={20}
                className="tw-bg-gray-200"
              />
            </div>
          ))}
        </div>

        {/* Chat Area Skeleton */}
        <div className="tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-w-full">
          <div className="tw-h-[calc(100vh-475px)] tw-px-8 tw-py-4 tw-space-y-6">
            {[1, 2, 3].map((index) => (
              <div
                key={index}
                className={`tw-space-y-2 ${
                  index % 2 === 0 ? "tw-flex tw-items-end tw-flex-col" : ""
                }`}
              >
                {/* Message Header */}
                <div className="tw-flex tw-items-center tw-space-x-2">
                  {index % 2 !== 0 && (
                    <>
                      <Skeleton
                        variant="circular"
                        width={32}
                        height={32}
                        className="tw-bg-gray-200"
                      />
                      <Skeleton
                        variant="text"
                        width={100}
                        height={24}
                        className="tw-bg-gray-200"
                      />
                    </>
                  )}
                  <Skeleton
                    variant="text"
                    width={80}
                    height={20}
                    className="tw-bg-gray-200"
                  />
                </div>

                {/* Message Content */}
                <div
                  className={`${
                    index % 2 === 0 ? "" : "tw-ml-10"
                  } tw-max-w-[558px]`}
                >
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={80}
                    className="tw-rounded-lg tw-bg-gray-200"
                  />
                </div>

                {/* Message Footer */}
                <div
                  className={`${
                    index % 2 === 0 ? "" : "tw-ml-10"
                  } tw-flex tw-items-center tw-gap-3`}
                >
                  <Skeleton
                    variant="text"
                    width={60}
                    height={20}
                    className="tw-bg-gray-200"
                  />
                  <Skeleton
                    variant="text"
                    width={60}
                    height={20}
                    className="tw-bg-gray-200"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Input Area Skeleton */}
          <div className="tw-px-8 tw-py-4">
            <div className="tw-relative tw-flex tw-items-center">
              <Skeleton
                variant="rectangular"
                width="100%"
                height={48}
                className="tw-rounded-lg tw-bg-gray-200"
              />
              <div className="tw-absolute tw-right-2">
                <Skeleton
                  variant="circular"
                  width={32}
                  height={32}
                  className="tw-bg-gray-200"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveChatFinancialDocumentSkeleton;
